import React, { useEffect, useRef, useState } from 'react';

const FadeSection = ({ children , effect, className, duration, delay }) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target); // Stop observing once the element is visible
          }
        });
      },
      { threshold: 0.5 } // Trigger when 70% of the element is visible
    );

    let sectionCurrentRef = sectionRef.current;

    if (sectionCurrentRef) {
      observer.observe(sectionCurrentRef);
    }

    return () => {
      if (sectionCurrentRef) {
        observer.unobserve(sectionCurrentRef);
      }
    };
  }, []);

  let transitionClass = '';

  // Determine transition effect based on the `effect` prop
  switch (effect) {
    case 'fade-left':
      transitionClass = isVisible
        ? 'opacity-100 translate-x-0'
        : 'opacity-0 translate-x-10';
      break;
    case 'fade-right':
      transitionClass = isVisible
        ? 'opacity-100 translate-x-0'
        : 'opacity-0 -translate-x-10';
      break;
    case 'fade-out':
      transitionClass = isVisible
        ? 'opacity-100 translate-y-0'
        : 'opacity-0 translate-y-10';
      break;
    case 'fade-in-down':
        transitionClass = isVisible
        ? 'opacity-100 translate-y-0'
        : 'opacity-0 -translate-y-10';
      break;
    case 'fade-in-up':  
    default:
      transitionClass = isVisible
        ? 'opacity-100 translate-y-0'
        : 'opacity-0 translate-y-10';
  }


  return (
    <div
      ref={sectionRef}
      className={`transition-all ${duration ? `${duration}` : 'duration-1000' } ${delay? `${delay}` :'delay-300'}  transform  ${ transitionClass } ${className }`}
    >
      {children}
    </div>
  );
};

export default FadeSection;